export const actionTriggerStyles = {
  cursor: "pointer" as const,
  fontSize: "sm" as const,
  fontWeight: 550,
  color: "gray.500",
  _hover: {color: "gray.700"},
};
